// src/components/common/ProtectedRoute.tsx

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../features/auth/hooks/useAuth";
import { Role } from "../../features/auth/types/auth.types";

interface ProtectedRouteProps {
    children: React.ReactNode;
    allowedRoles?: Role[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
                                                           children,
                                                           allowedRoles,
                                                       }) => {
    const { isAuthenticated, isLoading, userInfo } = useAuth();
    const location = useLocation();

    // On considère que userInfo est "chargé" quand sub != ""
    const isUserLoaded = isAuthenticated && userInfo.sub !== "";

    // Tant que le token ou le userInfo n'est pas prêt, on affiche un loader
    if (isLoading || (isAuthenticated && !isUserLoaded)) {
        return <div>Chargement…</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/connexion" state={{ from: location }} replace />;
    }

    if (allowedRoles && allowedRoles.length > 0) {
        const hasRole = userInfo.roles.some((r) => allowedRoles.includes(r));
        if (!hasRole) {
            return <Navigate to="/403" replace />;
        }
    }

    return <>{children}</>;
};

export default ProtectedRoute;
